export enum SearchMode {
  'searchStandard' = 'searchStandard',
  'searchErweitert' = 'searchErweitert',
  'searchDossiernummer' = 'searchDossiernummer',
  'fromGrundstueck' = 'fromGrundstueck',
  'searchFachId' = 'searchFachId',
  'searchZpv' = 'searchZpv'
}
